<app-loader *ngIf="loaderIcon | async"></app-loader>
<app-relink-email *ngIf="showRelinkPopup" #emailRelink (success)="onRelinkConfirmed($event)"></app-relink-email>
<div class="modal fade" bsModal #EmailDialog="bs-modal" [config]="modalConfig" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered modal_80" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">E-Mail</h5>
        <ul class="nav align-items-center" style="align-content: auto; position: absolute; right: 0px; margin-right: 50px;">
          <li class="nav-item">
            @if (viewRightAdHocEmail) {
            <div class="button_tooltip d-inline-block">
              <a class="btn btn-outline-primary" style="color: white; border-color: white;" href="javascript:void(0)"[class.disabled]="!createRightAdHocEmail"
                 [attr.aria-disabled]="!createRightAdHocEmail" (click)="createRightAdHocEmail && openComposeEmail()">+ COMPOSE</a>
              @if (!createRightAdHocEmail) {
              <div class="button_tooltip_modal" style="bottom: -55px; text-transform: none;">
                <p class="mb-0"> {{createRightFalseMessage}} </p>
                <i class="fa fa-caret-up text-dark h2 butt_downIcon" style="bottom: 24px;" aria-hidden="true"></i>
              </div>
              }
            </div>
            }
          </li>
        </ul>
        <button type="button" class="close" data-bs-dismiss="modal" (click)="onCancel()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="top_details">
          <ul>
            <li>
              <i class="pro_user button-color"></i>
              {{dataEmailLogs?.TenantName}}
            </li>
            <li>
              <i class="fa fa-phone"></i>
              {{dataEmailLogs?.CountryCode}} {{dataEmailLogs?.Phone| phone:1}}
            </li>
            <li>
              <i class="fa fa-map-marker"></i>
              {{dataEmailLogs?.Address}}, {{dataEmailLogs?.City}}, {{dataEmailLogs?.StateCode}} {{dataEmailLogs?.Zip}}
            </li>
          </ul>
        </div>

        <div class="row">
          <!-- LEFT SIDE TABS -->
          <div class="email-log-nav w-100">
            <ul class="nav align-items-center">
              <li class="nav-item">
                <a class="nav-link" [class.active]="selectedFilter === 'All'" href="javascript:void(0)" (click)="filterEmails('All')"><span>All</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="selectedFilter === 'Inbound'" href="javascript:void(0)" (click)="filterEmails('Inbound')"><span>Inbound</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="selectedFilter === 'Outbound'" href="javascript:void(0)" (click)="filterEmails('Outbound')"><span>Outbound</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="selectedFilter === 'Delivered'" href="javascript:void(0)" (click)="filterEmails('Delivered')"><span>Delivered</span></a>
              </li>
              <li class="nav-item">
                <a class="nav-link" [class.active]="selectedFilter === 'Failed'" href="javascript:void(0)" (click)="filterEmails('Failed')"><span>Failed</span></a>
              </li>
              <li *ngIf="groupingMode === 'none'" class="nav-item ms-auto">
                <span class="nav-link email-count">{{ filteredEmailLogs?.length || 0 }} EMAILS</span>
              </li>
              <li *ngIf="groupingMode === 'branches'" class="nav-item ms-auto">
                <span class="nav-link email-count">{{ groupedEmailsTotalCount || 0 }} EMAILS</span>
              </li>
              <li *ngIf="selectedFilter === 'Inbound'" class="nav-item">
                <a class="nav-link text-primary fw-bold" style="padding-bottom: 10px;" href="javascript:void(0)" (click)="markAllAsRead()">Mark All as Read</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" style="padding-bottom: 10px;" href="javascript:void(0)" id="viewSettingsDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="fa fa-sliders me-2"></i>View Settings
                </a>
                <ul class="dropdown-menu dropdown-menu-end" style="width: 225px" aria-labelledby="viewSettingsDropdown">
                  <li><h6 class="dropdown-header" style="font-size: revert;">MESSAGE GROUPING</h6></li>
                  <li>
                    <a class="dropdown-item" style="font-size: small;"
                       href="javascript:void(0)"
                       (click)="setGrouping('branches')">
                      Group messages by branches
                      <span class="text-primary fw-bold float-end" *ngIf="selectedGrouping === 'branches'">
                        ✓
                      </span>
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item" style="font-size: small;"
                       href="javascript:void(0)"
                       (click)="setGrouping('none')">
                      Do not group messages
                      <span class="text-primary fw-bold float-end" *ngIf="selectedGrouping === 'none'">
                        ✓
                      </span>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>

        <div class="row mx-0 mt-0">
          <div class="scroll_outer" style="--bs-gutter-x: 0;">
            <div class="scroll_inner_950">
                <div *ngIf="groupingMode === 'branches'">
                  <div class="group-grid-header row gx-0 text-uppercase fw-bold border-bottom py-2 mb-2 text-white" style="background-color: #3757C5;">
                    <div class="col-2 text-center">DATE & TIME</div>
                    <div class="col-1 text-center">UNIT</div>
                    <div class="col-2">SUBJECT</div>
                    <div class="col-2">FROM</div>
                    <div class="col-2">SENT TO</div>
                    <div class="col-2">CREATED BY</div>
                    <div *ngIf="selectedFilter === 'All'" class="col-1">TYPE</div>
                    <div *ngIf="selectedFilter === 'Outbound'" class="col-1">STATUS</div>
                  </div>
                  <div *ngFor="let g of groupedEmailLogs; let i = index" class="group-block mb-3">
                    <div class="group-header d-flex align-items-center justify-content-between p-2">
                      <div class="d-flex align-items-center">
                        <button class="btn p-0 me-2 toggle-icon" (click)="toggleGroup(i)">{{ g.expanded ? '▾' : '▸' }}</button>
                        <div class="group-title"><strong>{{ g.subject }}</strong></div>
                        <div class="group-count ms-3 text-muted">{{ g.count }} {{ g.count > 1 ? 'EMAILS' : 'EMAIL' }}</div>
                      </div>
                    </div>
                    <div class="group-items" *ngIf="g.expanded">
                      <div class="group-row row gx-0 py-2 align-items-center border-top" *ngFor="let item of g.items" (click)="rowSelectedEmailLogs({data: item})" style="cursor:pointer;" [class.fw-bold]="!item.IsRead">
                        <div class="col-2 text-center small">
                          {{ item.EmailDate }}
                        </div>
                        <div class="col-1 text-center">#{{ item.UnitNo }}</div>
                        <div class="col-2 small text-truncate" [title]="item.Description">{{ item.Description }}</div>
                        <div class="col-2 small text-truncate" [title]="item.FromEmailAddress">{{ item.FromEmailAddress }}</div>
                        <div class="col-2 small text-truncate" [title]="item.ToEmailAddress">{{ item.ToEmailAddress }}</div>
                        <div class="col-2 small text-truncate" [title]="item.UserName">{{ item.UserName }}</div>
                        <div *ngIf="selectedFilter === 'All'" class="col-1 small">{{ item.Type }}</div>
                        <div *ngIf="selectedFilter === 'Outbound'" class="col-1 small">{{ item.Status }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="groupingMode !== 'branches'">
                  <ejs-grid #gridEmailLog [dataSource]='filteredEmailLogs' [enableVirtualization]="false" class="Table_Height_store table-striped table-ipad"
                        [gridLines]='lines' (dataBound)='dataBound(gridEmailLog)' allowSorting='true'
                        height='480'
                        (rowSelected)='rowSelectedEmailLogs($event)'>
                    <e-columns>
                      <e-column field='EmailDate' headerText='DATE & TIME' width='130' textAlign='Center' type="string">
                        <ng-template #template let-data>
                          <span class="dataName">
                            {{data.EmailDate}}
                          </span>
                        </ng-template>
                      </e-column>
                      <e-column field='UnitNo' headerText='UNIT' width='60' textAlign='Center'>
                      </e-column>
                      <e-column field="Subject" headerText="SUBJECT" width="150" textAlign="Left">
                        <ng-template #template let-data>
                          <span [title]="data.Subject"
                                [class.fw-bold]="selectedFilter === 'Inbound' && !data.IsRead">
                            {{ data.Subject }}
                          </span>
                        </ng-template>
                      </e-column>
                      <e-column field="FromEmailAddress" headerText="FROM" width="130" textAlign="Left">
                        <ng-template #template let-data>
                          <span [title]="data.FromEmailAddress">
                            {{ data.FromEmailAddress }}
                          </span>
                        </ng-template>
                      </e-column>
                      <e-column field="ToEmailAddress" headerText="SENT TO" width="130" textAlign="Left">
                        <ng-template #template let-data>
                          <span [title]="data.ToEmailAddress">
                            {{ data.ToEmailAddress }}
                          </span>
                        </ng-template>
                      </e-column>
                      <e-column field='UserName' headerText='CREATED BY' width='130' textAlign='Left'>
                      </e-column>
                      <e-column field='Type' headerText='TYPE' width='100' textAlign='Center' [visible]="selectedFilter === 'All'" [customAttributes]="{ class: 'type-column-padding' }">
                        <ng-template #template let-data>
                          <div class="status-cell">
                            <span class="status-text">{{ data.Type }}</span>
                          </div>
                        </ng-template>
                      </e-column>
                      <e-column field='Status' headerText='Status' width='100' textAlign='Center' [visible]="selectedFilter === 'Outbound'" [customAttributes]="{ class: 'type-column-padding' }">
                        <ng-template #template let-data>
                          <div class="status-cell">
                            <span class="status-text">{{ data.Status }}</span>
                            <i class="fas fa-sync-alt refresh-icon" title="Refresh Status"
                               (click)="refreshEmailStatus(data, $event)">
                            </i>
                          </div>
                        </ng-template>
                      </e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
            </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-primary me-3" (click)="openPrintEmailLog()" [disabled]="!(listEmailLogs.length > 0)">Print Email Log</button>
            <button type="button" class="btn btn-primary" (click)="onCancel()" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
  </div>
</div>

<div class="modal fade" id="EmailLogSelected" #EmailLogSelected tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered">
    <div class="modal-content">

      <!-- Header -->
      <div class="modal-header text-white">
        <div>
          <button class="btn btn-outline-light btn-sm me-2"
                  data-bs-dismiss="modal">
            < BACK
          </button>
          <span class="fw-bold">E-MAIL</span>
        </div>

        <button type="button"
                class="btn-close btn-close-white"
                data-bs-dismiss="modal">
        </button>
      </div>

      <!-- Tenant Details -->
      <div class="border-bottom p-3 bg-light">
        <div class="d-flex align-items-center flex-wrap gap-4">

          <span class="bg-white text-dark">
            <i class="pro_user me-1"></i>
            {{dataEmailLogs?.TenantName}}
          </span>
          <span class="bg-white text-dark">
            <i class="fa fa-phone me-1"></i>
            {{dataEmailLogs?.CountryCode}}
            {{dataEmailLogs?.Phone | phone:1}}
          </span>

          <span class="bg-white text-dark">
            <i class="fa fa-map-marker me-1"></i>
            {{dataEmailLogs?.Address}},
            {{dataEmailLogs?.City}},
            {{dataEmailLogs?.StateCode}} {{dataEmailLogs?.Zip}}
          </span>

          <span class="unit-pill">
            <i class="fa fa-link me-2"></i>
            Unit #{{ unitNo }}
          </span>

          <button type="button"
                  class="btn btn-primary"
                  (click)="openRelinkPopup({Id: currentSelectedEmailLogId})">
            RELINK
          </button>

        </div>
      </div>

      <!-- Email Area -->
      <div class="modal-body bg-light" style="padding: 10px 85px;">

        <div class="d-flex">

          <!-- Content -->
          <div class="flex-grow-1">

            <div class="d-flex justify-content-between align-items-start">

              <div class="d-flex align-items-start">
                <div class="avatar-circle me-2">
                  {{ userName?.charAt(0) }}
                </div>

                <div>
                  <div class="fw-bold fs-5">
                    {{ userName }}
                  </div>

                  <div class="text-muted">
                    {{ toEmailAddress }}
                  </div>
                </div>
              </div>

              <div class="text-end">
                <div class="small text-muted">
                  {{ emailDate }}
                </div>

                <span class="badge bg-secondary mt-1">
                  {{ typeStatus }}
                </span>
              </div>

            </div>

            <!-- Email Card -->
            <div class="card mt-3 shadow-sm">

              <div class="card-header fw-bold fs-4 bg-white">
                {{emailSubject}}
              </div>

              <div class="card-body"
                   [innerHTML]="emailBody">
              </div>

              <div class="card-footer bg-white">
                @if (viewRightAdHocEmail) {
                <div class="button_tooltip d-inline-block me-4">
                  <button class="btn btn-sm" style="color: #0f3cd7; font-weight: bold;" [class.disabled]="!createRightAdHocEmail"
                          [attr.aria-disabled]="!createRightAdHocEmail" (click)="createRightAdHocEmail && ReplyEmail()">
                    REPLY
                  </button>
                  @if (!createRightAdHocEmail) {
                  <div class="button_tooltip_modal"
                       style="bottom: 30px; text-transform: none;">
                    <p class="mb-0"> {{createRightFalseMessage}} </p>
                    <i class="fa fa-caret-down text-dark h2 butt_downIcon" style="bottom: -24px;" aria-hidden="true"></i>
                  </div>
                  }
                </div>
                <div class="button_tooltip d-inline-block">
                  <button class="btn btn-sm" style="color: #0f3cd7; font-weight: bold;" [class.disabled]="!createRightAdHocEmail"
                          [attr.aria-disabled]="!createRightAdHocEmail" (click)="createRightAdHocEmail && ForwardEmail()">
                    FORWARD
                  </button>
                  @if (!createRightAdHocEmail) {
                  <div class="button_tooltip_modal" style="bottom: 30px; text-transform: none;">
                    <p class="mb-0"> {{createRightFalseMessage}} </p>
                    <i class="fa fa-caret-down text-dark h2 butt_downIcon" style="bottom: -24px;" aria-hidden="true"></i>
                  </div>
                  }
                </div>
                }
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>
</div>

<!-- Print Email Log -->
<div class="modal fade" id="PrintEmailLog" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Print Email Log</h5>
        <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group"><b>Period</b></div>
        <div class="row">
          <div class="col-md-7">
            <label>From Date</label>
            <div class="inputbox">
              <ejs-datepicker class="form-control p-0 h-auto" format='MM/dd/yyyy' [min]="minFromDateEmailLog"
                [max]="todaysdate" floatLabelType='Always' [(ngModel)]="fromDateEmailLog"
                (change)="changeEmailLogFromDate($event.value)">
              </ejs-datepicker>
            </div>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-7">
            <label>To Date</label>
            <div class="inputbox">
              <ejs-datepicker class="form-control p-0 h-auto" format='MM/dd/yyyy' [min]="minToDateEmailLog"
                [max]="todaysdate" floatLabelType='Always' [(ngModel)]="toDateEmailLog">
              </ejs-datepicker>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-outline-primary me-3" data-bs-dismiss="modal">Cancel</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" [disabled]="disablePrintEmailLog()"
          (click)="emailLogPrint()">Ok</button>
      </div>
    </div>
  </div>
</div>

<!-- Send Email Popup-->
<div class="modal fade" bsModal #EmailModal="bs-modal" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Send Email</h5>
        <button type="button" class="close" (click)="EmailModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row common_form">
          <label class="col-md-2">CHOOSE EMAIL TEMPLATE</label>
          <div class="col-md-6">
            <select class="form-select" [(ngModel)]="templateTTTypeID"
                    (ngModelChange)="onTemplateChange($event)">
              <option selected value="0" disabled>-Select-</option>
              <option *ngFor="let baseTemplate of letterTemplatelist" [value]="baseTemplate.Id">
                {{baseTemplate.Name}}
              </option>
            </select>
          </div>
        </div>
        <div class="row common_form mt-2">
          <label class="col-md-2">SELECT UNIT</label>
          <div class="col-md-6">
            <input *ngIf="isReplyClicked" type="text" class="form-control ng-pristine ng-valid ng-touched" style="width: 100%;" value="{{unitNo}}">
            <select *ngIf="isForwardClicked" class="form-select" [value]="dataEmailLogs.UnitNo" (change)="onUnitChange($event)">
              <option *ngFor="let unit of unitlist" [value]="unit.UnitNo">
                {{unit.UnitNo}}
              </option>
            </select>
            <select *ngIf="!isReplyClicked && !isForwardClicked" class="form-select" [value]="dataEmailLogs.UnitNo" (change)="onUnitChange($event)">
              <option *ngFor="let unit of unitlist" [value]="unit.UnitNo">
                {{unit.UnitNo}}
              </option>
            </select>
          </div>
        </div>
        <div class="row common_form mt-2">
          <label class="col-md-2">TO</label>
          <div class="col-md-6">
            <input type="text" class="form-control" style="width: 100%;" [(ngModel)]="toEmailAddress" (ngModelChange)="checkSendButtonState()">
          </div>
        </div>
        <div class="row common_form mt-2">
          <label class="col-md-2">CC</label>
          <div class="col-md-6">
            <input type="text" class="form-control ng-pristine ng-valid ng-touched" style="width: 100%;" [(ngModel)]="ccEmails" placeholder="cc@gmail.com (optional)">
          </div>
        </div>
        <div class="row common_form mt-2">
          <label class="col-md-2">BCC</label>
          <div class="col-md-6">
            <input type="text" class="form-control ng-pristine ng-valid ng-touched" style="width: 100%;" [(ngModel)]="bccEmails" placeholder="bcc@gmail.com (optional)">
          </div>
        </div>
        <div class="row common_form mt-2">
          <label class="col-md-2">SUBJECT</label>
          <div class="col-md-6">
            <input type="text" class="form-control" style="width: 100%;" [(ngModel)]="emailSubject" (ngModelChange)="checkSendButtonState()">
          </div>
        </div>
        <div class="row mx-0 mt-3">
          <ejs-richtexteditor *ngIf="showEditor" class="height400 mt-3 textareapos" #defaultRTE [(value)]="rteValue" (change)="checkSendButtonState()" (input)="checkSendButtonState()">
          </ejs-richtexteditor>
        </div>
      </div>
      <div class="modal-footer custom-footer">
        <button type="button"
                class="btn btn-outline-primary attach-btn"
                (click)="fileInput.click()">
          <i class="fa fa-paperclip me-2"></i>ATTACH FILE
        </button>

        <input #fileInput
               type="file"
               multiple
               hidden
               (change)="onFileSelected($event)" />

        <div class="footer-actions">
          <button type="button"
                  class="btn btn-link discard-btn"
                  (click)="EmailModal.hide()">
            Discard
          </button>

          <button type="button"
                  class="btn btn-primary send-btn"
                  (click)="sendEmail()"
                  [disabled]="isSendDisabled">
            <i class="fa fa-paper-plane me-2"></i>
            SEND EMAIL
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
